
<div mat-dialog>
    <img _ngcontent-pge-c105="" src="../../assets/images/myvista-logo-white.png" alt="logo" class="hoverLogo">


    <mat-toolbar class="mat-iwgGreen-theme">
        <div class="mat-toolbar-tools">
          <span class="vista-contctus">Terms of Use</span>
          <span flex></span>
          <button mat-button class="mat-icon-button" (click)="onDismiss()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </mat-toolbar>



    <div mat-dialog-content id="align-content" class="content"  [innerHTML]=message></div>
    <div mat-dialog-actions align="end" class="footer">
        <button class="closeBtn mat-button" mat-dialog-close (click)="onDismiss()">Close</button>
    </div>
</div>
